enum AiFeature {
  AI_PRODUCTS_SEO = "ai-products-seo",
  AI_PRODUCTS_NAME = "ai-products-name",
  AI_PRODUCTS_DESCRIPTION = "ai-products-description",
  AI_PRODUCT_IMAGE_ALT_TEXT = "ai-product-image-alt-text",
  AI_PRODUCTS_FROM_IMAGES = "ai-products-from-images",
  AI_CATEGORIES_SEO = "ai-categories-seo",
  AI_CATEGORIES_DESCRIPTION = "ai-categories-description",
  AI_PAGES = "ai-pages",
  AI_IMAGES_REMOVE_BG = "ai-images-remove-bg",
  AI_IMAGES_REPLACE_BG_COLOR = "ai-images-replace-bg-color",
  AI_IMAGES_REPLACE_BG_IMAGE = "ai-images-replace-bg-image",
  AI_IMAGES_SMART_ERASE = "ai-images-smart-erase",
  AI_GOOGLE_SHOPPING_CATEGORIES = "ai-google-shopping-categories",
  AI_PRODUCT_WEIGHTS_AND_DIMENSIONS = "ai-product-weights-and-dimensions",
  AI_PRODUCT_CATEGORY_SUGGESTIONS = "ai-product-category-suggestions",
  AI_PRODUCT_SEO_BRAND_TAGS = "ai-product-seo-brand-tags",
  AI_PRODUCT_SEO = "ai-product-seo",
  AI_PRODUCT_BRAND = "ai-product-brand",
  AI_PRODUCT_TAGS = "ai-product-tags",
  AI_AGENT_CHAT = "ai-agent-chat",
}

export default AiFeature;
